import React from 'react';
// import { useState,useEffect } from 'react';
import { Layout, Col, Row  } from 'antd';
// import { Grid, Menu, Dropdown } from 'antd';
// import { DownOutlined } from '@ant-design/icons';
import './AppHeader.scss';
import { Link } from 'react-router-dom';
// import UserService from "../../../services/UserService";
import { logo } from "../../../assets/images";
// import { Avatar } from 'antd';
// import RenderOnRole from 'components/RenderOnRole';
// import { useLocation } from 'react-router-dom';
import HeaderMenus from './HeaderMenus';
import HeaderMenusItems from './HeaderMenusItems';

const { Header } = Layout;
// const { useBreakpoint } = Grid;

function AppHeader() {
    // const [activeIndex, setActiveIndex] = useState<any>(0);
    // const location:any = useLocation();
    // useEffect(()=>{
    //     if(location?.pathname.includes("/housingcompany")){
    //         setActiveIndex(1);
    //     }else if(location?.pathname.includes("/housingcompaies-analysis")){
    //         setActiveIndex(1);
    //     }else if(location?.pathname==="/import"){
    //         setActiveIndex(2);
    //     }else{
    //         setActiveIndex(0);
    //     }
    // },[location])

    // const menu = (
    //     <Menu>
    //         <Menu.Item key="0" onClick={() => UserService.doLogout()}>
    //             Logout
    //         </Menu.Item>
    //     </Menu>
    // );

    // const administrationSubMenu = (
    //     <Menu>
    //         <Menu.Item key="1">
    //         <RenderOnRole roles={['app-moderator']}>

    //             <Link to="/import" replace >
    //                 Import
    //             </Link>
    //         </RenderOnRole>

    //         </Menu.Item>
    //     </Menu>
    // );

    return (
        <Header className="header">
            <nav className="menuBar">
                <Row>
                    <Col span={2} className="logo">
                        <Link to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                    </Col>
                    <Col span={10}>
                        {/* <Row>
                            <div className={`hover-underline-animation ${(activeIndex===1)?'active':''}`}>
                                <Link to="/housingcompany" replace className="text-white">
                                    Target Group
                                </Link>
                            </div>
                            <div className={`cu-cursor-pointer hover-underline-animation ${(activeIndex===2)?'active':''}`}>
                                <Dropdown overlay={administrationSubMenu} trigger={['click']}>
                                    <div>
                                        Administration
                                        <DownOutlined />
                                    </div>
                                </Dropdown>
                            </div>
                            <div className='cu-cursor-pointer'>
                                <Dropdown overlay={menu} trigger={['click']}>
                                    <div style={{color:'#fff'}}>
                                        <Avatar src="# style={{ backgroundColor: '#fde3cf',marginRight:"10px"}}/>
                                        {UserService.getUsername()}
                                        <DownOutlined />
                                    </div>
                                </Dropdown>
                            </div>
                        </Row> */}
                        <div >
                            <HeaderMenus menus={HeaderMenusItems}/>
                        </div>
                    </Col>
                </Row>
            </nav>
        </Header>
    );
}

export default AppHeader;
